import getAppName from '../../utils/getAppName';
import { OverlayType } from '../interface';
export function getOverlayDisplayConfig() {
  const overlaysFullScreen = ['automation-ui-index', 'automation-ui-creation', 'automation-ui-canvas', 'object-manager-settings-ui', 'web-interactives-editor-ui', 'FormsUI', 'SocialUI', 'crm-page-editor-ui', 'AdsUI', 'ads-demo', 'lead-flows-ui', 'web-interactives-dashboard-ui', 'settings-ui-users'];
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const overlaysWithToolbar = [];
  const overlaysWithToolbarAndNav = [];
  const showOverlaysWithToolbarAndNav = overlaysWithToolbarAndNav.some(appName => appName === getAppName());
  if (showOverlaysWithToolbarAndNav) {
    return {
      appName: getAppName(),
      [OverlayType.MODAL]: {
        shouldShowToolbar: true,
        shouldShowNav: true
      }
    };
  }
  const showOverlaysFullScreen = overlaysFullScreen.some(appName => appName === getAppName());
  if (showOverlaysFullScreen) {
    return {
      appName: getAppName(),
      [OverlayType.MODAL]: {
        shouldShowToolbar: false,
        shouldShowNav: false
      }
    };
  }
  return {
    appName: getAppName(),
    [OverlayType.MODAL]: {
      shouldShowToolbar: false,
      shouldShowNav: false
    }
  };
}